import { useNavigate } from "react-router-dom";
import { Division } from "../types";

interface DivisionCardProps {
  key: number;
  division: Division;
  settings_color_code: any;
}

const DivisionCard: React.FC<DivisionCardProps> = ({
  division,
  settings_color_code
}) => {
  
  const navigate = useNavigate();
  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;
  const divisionTime = `${division.start_time} - ${division.end_time}`;
  const d_performance_type = division?.color_code?.performance_type;
  const d_color_code = division?.color_code?.color_code;
  let color = settings_color_code?.value?.[d_performance_type][d_color_code];
  if(division?.status == "announced") color = "#c9c9c9";

  const canAccessTalktapeActions_dummmy = Boolean( JSON.parse(localStorage.getItem("user") || '{}')?.modules?.[7]?.ModulesPermissions?.view );
  console.log(canAccessTalktapeActions_dummmy);

  const canSeePerformances = [5,9].includes(currentRole);
  const canSeePlacements = [1,3,4,5,7,8].includes(currentRole);

  return (
  <div
    style={{
    backgroundColor: color,
    }}
    key={division.id}
    id="w-node-_2267a641-26cb-a0f0-d100-c5af7b7dd2cd-6473db02"
    className="division-card w-layout-cell cursor-pointer scale--sm"
  >
    <div className="division-card__text-box">
      <p className="paragraph-2">{divisionTime}</p>
      <h3 className="division-list-text">{division.title.split('_')[0]}</h3>
    </div>
    <div>
        {canSeePerformances && (
          <button
            className="action-btn"
            style={{ marginRight: "10px" }}
            onClick={() => navigate(`/performances/${division.id}`)}
          >
            Performances
          </button>
        )}

        {canSeePlacements && (
          <button
            className="action-btn"
            onClick={() => navigate(`/placements/${division.id}`)}
          >
            Placements
          </button>
        )}
      </div>

  </div>
  );
};

export default DivisionCard;
